module.exports = __webpack_public_path__ + "fonts/5b44818.ttf";